(function () {
  const CSS = `
    [class*="_formHeader_"] {
      text-align: center !important;
      margin-bottom: 16px !important;
    }
    [class*="_formHeader_"] [class*="_textHeading_"] {
      font-family: 'Poppins';
font-style: normal;
font-weight: 600;
font-size: 30px;
line-height: 38px;
color: #103E68;
    }
    [class*="_formHeader_"] [class*="_textBody_"] {
      font-family: 'Lora';
font-style: normal;
font-weight: 400;
font-size: 18px;
line-height: 25px;
color: #103E68;
    }
  `;

  let done = false;

  const inject = () => {
    if (done) return true;
    const root = document.getElementById('app-embed')?.shadowRoot;
    if (!root) return false;

    const sheet = new CSSStyleSheet();
    sheet.replaceSync(CSS);
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    done = true;
    console.log('✅ estilos inyectados');
    return true;
  };

  if (!inject()) {
    const t = setInterval(() => { if (inject()) clearInterval(t); }, 300);
    setTimeout(() => clearInterval(t), 15000);
  }
})();